// import SocialLinks from "./SocialLinks";
// import { FaGithub, FaLink, FaTwitter } from "react-icons/fa";

const Footer = ({ githubUrl, link, twitter }) => {
  return (
    <footer className="d-flex flex-column justify-content-center align-items-center bg-dark">
      {/* <SocialLinks githubUrl={githubUrl} link={link} twitter={twitter} /> */}
      {/* <a href="http://github.com/jpmc3630" target="_blank" rel="noreferrer">
        <FaGithub />
      </a> */}
      <br></br>
      <p className="text-muted text-center">© 2020 James McGlone</p>
      {/* <br></br> */}
    </footer>
  );
};

export default Footer;
